// extracted by mini-css-extract-plugin
module.exports = {"landingContainer":"landing-module--landingContainer--N3-1u"};